export const ActionTypes = {
  LOGIN_SUCCESS: "LOGIN_SUCCESS",
  LOGIN_ERROR: "LOGIN_ERROR",
  SIGNUP_SUCCESS: "SIGNUP_SUCCESS",
  SIGNUP_ERROR: "SIGNUP_ERROR",
  LOGOUT_SUCCESS: "LOGOUT_SUCCESS",
  LOGOUT_ERROR: "LOGOUT_ERROR",
  USER_FOLLOWED: "USER_FOLLOWED",
  USER_FOLLOWED_ERROR: "USER_FOLLOWED_ERROR",
  USER_UNFOLLOWED: "USER_UNFOLLOWED",
  USER_UNFOLLOWED_ERROR: "USER_UNFOLLOWED_ERROR",
  BOOKMARK_SUCCESS: "BOOKMARK_SUCCESS",
  REMOVE_BOOKMARK_SUCCESS: "REMOVE_BOOKMARK_SUCCESS",
  DELETE_POST_SUCCESS: "DELETE_POST_SUCCESS",
  DELETE_POST_ERROR: "DELETE_POST_ERROR",
};
